import { Box, CircularProgress, Typography } from '@mui/material'

const Loader = ({ height, text }) => {

  return (
    <Box display={'flex'} justifyContent='center'
      alignItems={'center'} height={height && height} flexDirection='column' gap='20px'>

      <CircularProgress size={60}/>
      {text && (
        <p
        className='text-gray-500 text-xs animate-pulse'
        >{text}</p>
      )}
    </Box>
  )
}

export default Loader